// extracted by mini-css-extract-plugin
export default {"root":"_1tKE2","button":"_2J4R2","is-active":"DnjJp","isActive":"DnjJp"};